import imageIcon from 'assets/icons/image.svg';
import React, { useMemo } from 'react';
import { IMusicProductDigitalDeliveryServiceResponse } from 'services/music-product-digital/types/query';

import LabeledDeliveryStatus from 'components/molecules/labeledStatus/LabeledDeliveryStatus';
import DeliveryDiscrepancyPopup from 'components/molecules/popup/delivery-discrepancy/DeliveryDiscrepancyPopup';
import { DELIVERY_STATUS } from 'services/music-product-digital/types/enums';
import './DeliveryCard.scss';

interface IDeliveryCardProp {
  service: IMusicProductDigitalDeliveryServiceResponse;
  onClick: React.MouseEventHandler<HTMLDivElement> | undefined;
}

const DeliveryCard = ({ service, onClick }: IDeliveryCardProp) => {
  const deliveryProgress = useMemo(() => {
    const index = deliveryStatusProgress.findIndex(
      s => s === service.deliveryStatus
    );
    if (index === -1) return 0;
    return Math.ceil(((index + 1) / deliveryStatusProgress.length) * 100);
  }, [service.deliveryStatus]);
  return (
    <div
      onClick={e =>
        service.deliveryStatus !== DELIVERY_STATUS.unavailable &&
        onClick &&
        onClick(e)
      }
      className={`delivery-card-wrapper ${
        DELIVERY_STATUS[service.deliveryStatus]
      }`}>
      <div className='delivery-card-image'>
        <img
          src={service.logoImageUrl ?? imageIcon}
          alt='imagee'
          onError={e => {
            e.currentTarget.onerror = null;
            e.currentTarget.src = imageIcon;
          }}
        />
      </div>

      <div className='delivery-card'>
        <div className='delivery-card-header'>
          <div className='delivery-card-title'>{service.salesChannelName}</div>
          <div className='delivery-card-description'>
            {service.providerName}
          </div>
        </div>
        <div className='flex items-center gap-2'>
          <LabeledDeliveryStatus status={service.deliveryStatus} />
          {service.hasDiscrepancy && (
            <DeliveryDiscrepancyPopup
              name={`${service.salesChannelName} ${service.providerName}`}
              onGoToDelivery={e => onClick && onClick(e as any)}
            />
          )}
        </div>
      </div>
      {!!deliveryProgress && (
        <div
          className='delivery-card-progress'
          style={{ width: `${deliveryProgress}%` }}>
          {deliveryProgress}%
        </div>
      )}
    </div>
  );
};

export default DeliveryCard;

const deliveryStatusProgress = [
  // DELIVERY_STATUS.notSend,
  DELIVERY_STATUS.waiting,
  DELIVERY_STATUS.inProgress,
  DELIVERY_STATUS.waitingForACKFile,
  DELIVERY_STATUS.inProgressProcessingACKFile,
  DELIVERY_STATUS.waitingForAssetIds,
  DELIVERY_STATUS.inProgressAssigningAssetIds,
  DELIVERY_STATUS.publishWaiting,
  999,
];
